/**
 * Flutter event names for communication between web and Flutter.
 * These events are thrown on the Flutter side and used for web to flutter communication.
 */
export const enum FlutterEvents {
  // App check
  NEW_NATIVE_APP_CHECK_TOKEN = "newNativeAppCheckToken",
  NEW_NATIVE_APP_CHECK_TOKEN_ERROR = "newNativeAppCheckTokenError",
}
